import { createContext, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

import { useAccess } from '../hooks/useAccess';
// import Loading from '../components/Loading';

const AccessContext = createContext(undefined);

export const AccessProvider = ({ children }) => {
  const pathname = useLocation();
  const { access, accessLoading, accessError, hasAccess } = useAccess();
  const [isPremiumModalOpen, setIsPremiumModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');

  useEffect(() => {
    setIsPremiumModalOpen(false);
  }, [pathname]);

  const showPremiumModal = (message) => {
    setModalMessage(message);
    setIsPremiumModalOpen(true);
  };

  const hidePremiumModal = () => {
    setIsPremiumModalOpen(false);
    setModalMessage('');
  };

  // if (accessLoading) {
  //   return <Loading />;
  // }

  return (
    <AccessContext.Provider
      value={{
        access,
        accessLoading,
        accessError,
        hasAccess,
        isPremiumModalOpen,
        modalMessage,
        showPremiumModal,
        hidePremiumModal,
      }}
    >
      {children}
    </AccessContext.Provider>
  );
};

AccessProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useAccessContext = () => {
  const context = useContext(AccessContext);
  if (!context) {
    throw new Error('useAccessContext must be used within AccessProvider');
  }
  return context;
};
